// extracted by mini-css-extract-plugin
export default {"ide-content__spliter":"ideContent_ide-content__spliter__v6BHA"};